import styled from "styled-components";
import { colors } from "../../theme/colors";
import { TextField } from "@mui/material";

export const ProductWrapper = styled.div`
  text-align: center;
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 15px;
  width: ${(props) => (props.size ? props.size : "180px")};
  max-width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  margin: auto;
  background-color: ${(props) =>
    props.hasImage ? colors.white.main : colors.secondary};
  justify-content: center;
  overflow: hidden;
  margin-top: 0.5rem;

  &:hover {
    border: 1px ${colors.secondary} solid;
  }

  @media screen and (max-width: 450px) {
    width: 25%;
    margin-top: 1%;
  }
`;

export const ProductWrapperList = styled.div`
  text-align: center;
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 15px;
  width: ${(props) => (props.size ? props.size : "180px")};
  max-width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  margin: auto;
  background-color: ${(props) =>
    props.hasImage ? colors.white.main : colors.secondary};
  justify-content: center;
  overflow: hidden;
  margin-top: 0.5rem;

  &:hover {
    border: 1px ${colors.secondary} solid;
  }
`;

export const ProductName = styled.div`
  color: ${(props) => props.color};
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  width: 180px;
  margin: 2rem auto 1rem auto;
  line-height: 24px;
  height: ${(props) => (props.height ? props.height : "auto")};

  @media screen and (max-width: 600px) {
    font-size: 18px;
    margin: 0.5rem auto;
    text-align: start;
    height: auto;
  }
`;

export const StyledCenteredLabelTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    right: 0,

    "&.Mui-focused": {
      color: colors.secondary,
    },
  },
  "& .MuiInputLabel-shrink": {
    margin: "0 auto",
    position: "absolute",
    right: "0",
    left: "50%",
    top: "-3px",
    padding: "0 1rem",
    width: "fit-content",
    background: "white",
    fontSize: "1.25rem",
    transform: "translate(-50%, -50%)",
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    "&label.Mui-focused": {
      color: colors.secondary,
    },
    "& fieldset": {
      borderColor: colors.secondary,
    },
    "& legend ": {
      display: "none",
    },

    "& .MuiInputAdornment-root": {
      color: colors.secondary,
    },
  },

  "& input[type=number]": {
    "-moz-appearance": "textfield",
  },
  "& input[type=number]::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "& input[type=number]::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
});
